export default {"src":"/_next/static/media/fantom.aa726f78.svg","height":128,"width":493,"blurWidth":0,"blurHeight":0};